import { render, staticRenderFns } from "./updateMedicalOrder.vue?vue&type=template&id=0f994a24&scoped=true&"
import script from "./updateMedicalOrder.vue?vue&type=script&lang=js&"
export * from "./updateMedicalOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateMedicalOrder.vue?vue&type=style&index=0&id=0f994a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f994a24",
  null
  
)

export default component.exports